import React, {Component} from 'react';
import {controlMaxWidthStyle, errorMessageStyle} from '../styles';
import AuthenticationService from './authentication-service';

export default class RequestPasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isResetting: false,
            isReset: false,
            errorMessage: ''
        };
        this.service = AuthenticationService;
    }

    inputChanged = e => {
        const state = this.state;
        state[e.target.id] = e.target.value;
        this.setState(state);
    };

    isValid = () => {
        return !!this.state.email;
    };

    requestReset = () => {
        this.setState({isResetting: true, errorMessage: ''});
        this.service.requestPasswordReset(this.state.email)
            .done(() => this.setState({isReset: true}))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isResetting: false}));
    };

    render() {
        const requestForm = (
            <form className="form-horizontal">
                <h4 style={{marginBottom: '20px'}}>Request password reset</h4>
                <div className="form-group">
                    <label htmlFor="email" className="col-sm-2 control-label">Email</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="email"
                               placeholder="Email"
                               value={this.state.email}
                               onChange={this.inputChanged}
                               onBlur={this.validate}/>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-10">
                        {this.state.isResetting ?
                            <button type="button" className="btn btn-default" disabled>Requesting...</button> :
                            this.isValid() ?
                                <button type="submit" className="btn btn-default" onClick={this.requestReset}>Request Reset</button> :
                                <button type="button" className="btn btn-default" disabled>Request Reset</button>}
                        <button type="button"
                                className="btn btn-default"
                                style={{marginLeft: '15px'}}
                                onClick={this.props.onCancel}>Cancel</button>
                    </div>
                </div>
                {this.state.errorMessage ?
                    <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                        <div className="alert alert-danger" style={errorMessageStyle} >{this.state.errorMessage}</div>
                    </div>
                    : undefined}
            </form>
        );
        const resetRequested = (
            <div>
                <p>A password reset has been sent to the provided email address.</p>
                <button type="button" className="btn btn-default" onClick={this.props.onCancel}>Close</button>
            </div>
        );

        return this.state.isReset ? resetRequested : requestForm;
    }
}


// WEBPACK FOOTER //
// ./src/auth/request-password-reset.js